import { Badge, NewHome } from '@zoopla-eng/zds-components/badges';
import { Listing } from './listing.type';

export const getStatus = (listing: Listing) => {
    const badges: React.ReactNode[] = [];

    if (listing.underOffer) {
        badges.push(<Badge text="Under offer" level={3} />);
    }

    if (listing.flag) {
        let text = listing.flag;

        if (listing.flag === 'Sold subject to contract') {
            text = 'Sold STC';
        }

        badges.push(<Badge text={text} level={2} />);
    }

    if (listing.tags?.find((tag) => tag?.content === 'New home')) {
        badges.push(<NewHome />);
    }

    return badges;
};
